import React, { useState } from "react";

const AuthContext = React.createContext({
    token : localStorage.getItem("token"),
    isLoggedIn : false,
    userIdentifier : localStorage.getItem("userIdentifier"),
    hasAccessTo : localStorage.getItem("hasAccessTo"),
    login : (token) => {},
    logout : () => {}
});

export const AuthContextProvider = (props) => {
    const [token, setToken] = useState(localStorage.getItem('token'));
    const [userIdentifier, setUserIdentifier] = useState(localStorage.getItem('userIdentifier'));
    const [hasAccessTo, setHasAccessTo] = useState(localStorage.getItem('hasAccessTo'))
    
    const userIsLoggedIn = !!token;

    const loginHandler = (token, userIdentifier, hasAccessTo) => {
        localStorage.setItem("token", token);
        localStorage.setItem("userIdentifier", userIdentifier);
        localStorage.setItem("hasAccessTo", JSON.stringify(hasAccessTo));
        setToken(token);
        setUserIdentifier(userIdentifier)
        setHasAccessTo(JSON.stringify(hasAccessTo))
    }

    const logoutHandler = () => {
        setToken(null);
        setUserIdentifier(null)
        setHasAccessTo(null)
        localStorage.removeItem("token");
        localStorage.removeItem("userIdentifier");
        localStorage.removeItem("hasAccessTo");
    }
    
    const contextValue = {
        token : token,
        isLoggedIn : userIsLoggedIn,
        userIdentifier : userIdentifier,
        hasAccessTo : hasAccessTo,
        login: loginHandler,
        logout: logoutHandler
    }

    return <AuthContext.Provider value={contextValue}>{props.children}</AuthContext.Provider>
}

export default AuthContext;